import Vue from 'vue';
export default {
  SET_MOBILE(state, version) {
    state.mobileVersion = version;
  },
  SET_PAGE(state, name) {
    state.pageName = name;
  },
  SET_SEARCH(state, open) {
    state.search = open;
  },
  SET_SEARCH_WORD(state, write) {
    state.searchWrite = write;
  },
  SET_STATE : function (state, data) {
    // Validate data key & value not equal false
    if (! data.key) return false;
    Vue.set(state, data.key, data.val);
  },

};
